import { render, staticRenderFns } from "./MarketBookingList.vue?vue&type=template&id=f5fd6506&scoped=true&"
import script from "./MarketBookingList.vue?vue&type=script&lang=js&"
export * from "./MarketBookingList.vue?vue&type=script&lang=js&"
import style0 from "./MarketBookingList.vue?vue&type=style&index=0&id=f5fd6506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fd6506",
  null
  
)

export default component.exports